export var EMAIL_REQUEST_TYPE;
(function (EMAIL_REQUEST_TYPE) {
    EMAIL_REQUEST_TYPE["PROPERTY_OWNER_TERMINATION_NOTIFICATION"] = "PROPERTY_OWNER_TERMINATION_NOTIFICATION";
    EMAIL_REQUEST_TYPE["RESIDENT_APPROVED_NOTIFICATION"] = "RESIDENT_APPROVED_NOTIFICATION";
})(EMAIL_REQUEST_TYPE || (EMAIL_REQUEST_TYPE = {}));
export var EMAIL_REQUEST_STATUS;
(function (EMAIL_REQUEST_STATUS) {
    EMAIL_REQUEST_STATUS["FAILED"] = "FAILED";
    EMAIL_REQUEST_STATUS["FULFILLED"] = "FULFILLED";
    EMAIL_REQUEST_STATUS["REQUESTED"] = "REQUESTED";
})(EMAIL_REQUEST_STATUS || (EMAIL_REQUEST_STATUS = {}));
//# sourceMappingURL=EmailRequest.js.map